import React from 'react';

import { Box, Divider, Grid, Hidden, Typography } from '@material-ui/core';
import {
  ButtonNext,
  CarouselProvider,
  Slide,
  Slider,
} from 'pure-react-carousel';

// import AnswerBackgroundImg from '../../../../assets/img/prelogin/AnswerBackgroundImg.png';
import Arrow from '../../../../assets/img/prelogin/Arrow.png';
// grey icon
import AsistanceAnswer from '../../../../assets/img/prelogin/AsistanceAnswer.svg';
import ComplainAnswer from '../../../../assets/img/prelogin/ComplainAnswer.svg';
import PaymentsAnswer from '../../../../assets/img/prelogin/PaymentsAnswer.svg';
import Self_management from '../../../../assets/img/prelogin/Self_management.svg';
// blue icons
// import AsistanceAnswer from '../../../../assets/img/prelogin/AsistanceAnswer.png';
// import ComplainAnswer from '../../../../assets/img/prelogin/ComplainAnswer.png';
// import PaymentsAnswer from '../../../../assets/img/prelogin/PaymentsAnswer.png';
// import Self_management from '../../../../assets/img/prelogin/Self_management.png';
import { appConfig } from '../../../../config/app';
import FeatureCard from './Components/FeatureCard';
import StoresCard from './Components/StoresCard';
import { styles, useStyles } from './styles';

const LandingAnswer = ({ children }) => {
  const classes = useStyles();

  const featureCardsData = [
    {
      description: 'Aboná con Mercado Pago',
      img: PaymentsAnswer,
    },
    {
      description: 'Denuncia de Siniestro',
      img: ComplainAnswer,
    },
    {
      description: 'Solicitá asistencias',
      img: AsistanceAnswer,
    },
    {
      description: '¡Empezá a autogestionar tu seguro!',
      img: Self_management,
    },
  ];

  const ArrowIcon = () => {
    return <img src={Arrow} alt="Arrow" style={styles.buttonNext} />;
  };

  return (
    <Grid>
      <Grid container direction="row">
        <Grid item xs={12} sm={6} md={5}>
          <Box className={classes.leftSideContainer}>
            <Box className={classes.answerLog}>
              <img
                src={appConfig?.IMAGES?.HOME_HEADER}
                style={styles.logoAnswerWidth}
                alt="brand logo"
              />
            </Box>
            <Typography gutterBottom className={classes.leftTitle}>
              Sucursal Digital
            </Typography>
            {children}
          </Box>
        </Grid>
        <Hidden xsDown>
          <Grid
            direction="row"
            container
            sm={6}
            md={7}
            className={classes.rightSideContainer}
          >
            <Grid item sm={6}>
              <Hidden smDown>
                <Box className={classes.cardsContainer}>
                  {featureCardsData.map((card, index) => (
                    <FeatureCard
                      key={index}
                      description={card.description}
                      img={card.img}
                    />
                  ))}
                </Box>
              </Hidden>
            </Grid>
            <Grid
              sm={6}
              container
              direction="column"
              alignContent="flex-end"
              justify="space-between"
              alignItems="flex-end"
            >
              <StoresCard />
              {/* <img
                src={AnswerBackgroundImg}
                alt="AnswerBackgroundImg"
                style={styles.answerBackgroundImg}
              /> */}
            </Grid>
          </Grid>
        </Hidden>
      </Grid>
      <Hidden mdUp>
        <Grid className={classes.bottomContainer}>
          <Hidden smUp>
            <StoresCard />
          </Hidden>
          <Divider className={classes.divider} variant="middle" />
          <Typography className={classes.carruselTitle}>
            En la sucursal digital podrás
          </Typography>
          <Box mt={4} mb={4}>
            <CarouselProvider
              naturalSlideWidth={290}
              naturalSlideHeight={138}
              totalSlides={featureCardsData.length}
              isIntrinsicHeight
              visibleSlides={1.05}
              infinite
              isPlaying
              interval={3000}
            >
              <Slider>
                {featureCardsData?.map((card, index: number) => (
                  <Slide key={`FeatureCard_${index}`} index={index}>
                    <FeatureCard
                      description={card.description}
                      img={card.img}
                    />
                  </Slide>
                ))}
              </Slider>
              <Box className={classes.buttonNextBox}>
                <ButtonNext className={classes.buttonNext}>
                  <ArrowIcon />
                </ButtonNext>
              </Box>
            </CarouselProvider>
          </Box>
        </Grid>
      </Hidden>
    </Grid>
  );
};

LandingAnswer.displayName = 'LandingAnswer';
export default LandingAnswer;
